import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {BaseComponent, ClassificatorValuesQuery, LeModalService, UsersQuery} from "common-shared";
import {EditItemLogModalComponent} from "./edit-item-log-modal/edit-item-log-modal.component";
import {ItemLogModel} from "../models/item-log.model";
import {ManufacturingItemService} from "../manufacturing-item.service";

@Component({
  selector: 'app-item-log',
  templateUrl: './item-log.component.html',
  styles: []
})
export class ItemLogComponent extends BaseComponent implements OnInit {

  @Input() itemId: string;
  @Input() context: string[] = [];
  @Output() logAdded = new EventEmitter<ItemLogModel>();
  logs: ItemLogModel[] = [];

  constructor(private itemService: ManufacturingItemService, private leModalService: LeModalService, public classificatorValuesQuery: ClassificatorValuesQuery, public usersQuery: UsersQuery) {
    super();
  }

  ngOnInit(): void {
    this.loadLogs();
  }

  addLog() {
    this.itemService.getStatusClassificator(this.itemId).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.leModalService.show(EditItemLogModalComponent, {initialState: {statusCl: value, log: new ItemLogModel({ItemId: this.itemId, Start: new Date(), StatusClv: this.logs.find(value => true)?.StatusClv})}}).onHide$.subscribe(value1 => {
        let data = value1.data as ItemLogModel;
        this.logAdded.emit(data);
        this.loadLogs();
      });
    });
  }

  editLog(row: ItemLogModel) {
    this.itemService.getStatusClassificator(this.itemId).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.leModalService.show(EditItemLogModalComponent, {initialState: {statusCl: value, log: row, mode: 'edit'}}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(value1 => {
        this.loadLogs();
      });
    });
  }

  private loadLogs() {
    this.itemService.getLogs(this.itemId, this.context).pipe(takeUntil(this.componentDestroyed)).subscribe(value1 => {
      this.logs = value1;
    });
  }
}
